import { nextTick } from "vue";
import pym from "pym.js";

const SHASHA = "e3ef9f72-9b02-4058-a68e-2cb567865ba9";

export const pymChild = pym.Child();

let resolveInitPromise;
export const initPromise = new Promise((resolve) => {
  resolveInitPromise = resolve;
});
if (window === window.top) {
  // e.g. https://local.dev.slate.com:8080/news-quiz/?slug=220318&display_name=%3Cscript%3Ealert(%22xss?%22)%3C%2Fscript%3E&is_plus=false
  const { searchParams: p } = new URL(location.href);
  const initStub = {
    slug: p.get("slug") || "",
    user: {
      uid: p.get("uid") || "",
      display_name: p.get("display_name") || "",
      is_plus: !!JSON.parse(p.get("is_plus") || "false"),
      has_leaderboard_access: !!JSON.parse(
        p.get("has_leaderboard_access") || "false"
      ),
    },
  };
  console.debug("not embedded, initializing with querystring", initStub);
  resolveInitPromise(initStub);
}

// opt into smooth scrolling on the parent
pymChild.sendMessage("polyfillSmoothScroll");
pymChild.sendMessage("ready");
pymChild.onMessage("init", (initData) => {
  const initJson = JSON.parse(initData);
  resolveInitPromise(initJson);
});

let prevRootClass;
pymChild.onMessage("rootClass", (rootClass) => {
  document.documentElement.classList.remove(prevRootClass);
  document.documentElement.classList.add(rootClass);
  prevRootClass = rootClass;
});

// this is janky but i dunno how better to do it given what pym provides
let resolveParentPosition = () => {};
pymChild.onMessage("viewport-iframe-position", function (parentInfo) {
  // https://blog.apps.npr.org/pym.js/api/pym.js/1.3.2/pym.js.html#line679
  const [
    viewportWidth,
    viewportHeight,
    iframeTop,
    iframeLeft,
    iframeBottom,
    iframeRight,
  ] = parentInfo.split(/\s/).map((x) => Number(x));
  resolveParentPosition({
    viewportHeight,
    viewportWidth,
    iframeTop,
    iframeLeft,
    iframeBottom,
    iframeRight,
  });
});

export function getParentPositionInfo() {
  return new Promise(function (resolve) {
    resolveParentPosition = resolve;
    pymChild.getParentPositionInfo();
  });
}

export async function scrollElIntoView(el, opts = {}) {
  opts = { behavior: "smooth", ...opts };

  if (window === window.top) {
    // sadly this doesn't work coming from embeds in Safari, or we wouldn't need an "else" case
    // but at least we can use it for the local development scenario outside of iframes
    const rect = el.getBoundingClientRect();
    // don't bother scrolling if the element is already on the page
    if (
      (opts.block === "end" &&
        rect.bottom > document.documentElement.clientHeight) ||
      (opts.block.slice(0, 5) === "start" &&
        (rect.top < 0 || rect.bottom > document.documentElement.clientHeight))
    )
      el.scrollIntoView(opts);
  } else {
    await nextTick();

    // purposefully using the Safari fallback method for *all* browsers, not just Safari,
    // just to keep things simpler, consistent, and resilient
    const rect = el.getBoundingClientRect();
    const data = JSON.stringify({ rect, opts });

    pymChild.sendMessage("scrollChildElIntoView", data);
  }
}

export function scrollParentBy(opts) {
  // if we don't json stringify it, pym will to string it to "[object Object]" 🤦
  pymChild.sendMessage("scrollBy", JSON.stringify(opts));
}

export const getCookieValue = (name) =>
  document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

export const setLocalStorageQuiz = (slug, data) => {
  window.localStorage.setItem(`quiz-${slug}`, data);
};

export const getLocalStorageQuiz = (slug) => {
  return window.localStorage.getItem(`quiz-${slug}`);
};

export const removeLocalStorageQuiz = (slug) => {
  window.localStorage.removeItem(`quiz-${slug}`);
};

export function isShasha(userId) {
  return userId === SHASHA;
}

export function redirectBack(e) {
  let targetUrl = e.target;
  let url = new URL(targetUrl.href);
  let quizPageUrl = new URL(location.href).searchParams.get("parentUrl");
  url.searchParams.set("redirect_uri", quizPageUrl);
  targetUrl.href = url.href;
}
